import { enableProdMode } from "@angular/core";
import { registerLocaleData } from "@angular/common";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";
import localeEs from "@angular/common/locales/es";
import localePt from "@angular/common/locales/pt";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";

registerLocaleData(localeEs);
registerLocaleData(localePt);

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
